import { GlobalStatus } from "@gtpl/shared-models/common-models";

export class UpdateSoInspectionRequest{
    soInspectionId?:number;
    saleOrderId:number;
    isChecked:GlobalStatus;
    inspectionName: string;
}

